import React from "react"
import { Badge } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { SerialNumberLabelListingProps } from "../../common/types"

const SerialNumberLabelListing = (props: SerialNumberLabelListingProps) => {

    return <>{
        props.serialNumbers && props.serialNumbers.length > 0 &&
            <div className={"d-flex flex-wrap pb-1"}>
                {props.serialNumbers.map((s, i) => {
                    return (
                        !props.isPdf ? <div key={i} className={"pr-1"}>
                            <Badge
                                className={"p-1"}
                                variant="secondary">{s.attributes.serial}
                            </Badge>
                        </div> :
                            <div className="badge badge-secondary">
                                {s.attributes.serial}
                            </div>
                        
                    )
                })}
            </div>
    }</>
}

export default injectIntl(SerialNumberLabelListing)



// WEBPACK FOOTER //
// ./src/product/serial-number/SerialNumberLabelListing.tsx